import PropTypes from "prop-types";
import styles from "./MainContent.module.css";

const MainContent = ({ children }) => {
  return (
    <div className={styles.mainContent}>
      {/* Children (Form and Footer) */}
      {children}
    </div>
  );
};

MainContent.propTypes = {
  children: PropTypes.node.isRequired,
};

export default MainContent;
